import {
  authedRequest,
  authedFormRequest,
  setFormData,
  objectToFormData,
  authedSlugValidationRequest,
} from './requests';
import { normalize, schema } from 'normalizr';
//For time zone
import moment from 'moment';
import tz from 'moment-timezone';
import { isString } from '../helpers';
// Define schema
const channel = new schema.Entity('allChannels', {
  client: new schema.Entity('clients'),
  channel_theme_instance: new schema.Entity('channelThemeInstances'),
});

/**
 *
 * /channels resource requests
 *
 */
export const getChannels = (token, params) => authedRequest(`v2/channels${params}`, token).then(r => r);

export const validateChannel = (token, id) => authedSlugValidationRequest(`v2/channels/${id}`, token).then(r => r)
;



export const getChannelDetail = (token, id) =>
  authedRequest(`v2/channels/${id}`, token).then((r) => ({
    ...r,
    big_logo_image_url:
      r.big_logo_image_url && r.big_logo_image_url.endsWith("missing.png")
        ? null
        : r.big_logo_image_url,
        channel_theme_instance: r.channel_theme_instance ? r.channel_theme_instance : {
          ...r.channel_theme_instance,
          with_photo_filter: false,
        },
    overlay_image:
      r.overlay_image_url && ['missing.png','overlay_image.png'].some(item => r.overlay_image_url.endsWith(item))
        ? null
        : r.overlay_image_url,
    mode_id: r.mode ? r.mode.id : null
  }));

export const deleteChannel = (token, { channelId }) => {
  return (
    authedRequest(`v2/channel/${channelId}`, token, { method: 'DELETE' }).then(r => r));
}

export const postChannel =
  (token, payload) => {
    const params = objectToFormData({
      channel: {
        app_background_color: payload.background,
        ...payload,
        channel_theme_instance_attributes: {
          channel_theme_id: payload.channel_theme_id,
          first_line_text: payload.first_line_text,
          second_line_text: payload.second_line_text,
          first_line_font_shrink: payload.first_line_font_shrink,
          second_line_font_shrink: payload.second_line_font_shrink,
          with_photo_filter: payload.with_photo_filter,
          with_photo_filter_graphic: payload.with_photo_filter_graphic,
        },
        channel_image_customization: payload.channel_image_customization || {
          is_black_and_white_mode_enabled: false,
          is_glitch_mode_enabled: false
        },
        active_until: payload.active_until ? payload.active_until.format() : "",
        event_date: payload.event_date ? payload.event_date.format() : "",
      },
      client: {
        name: payload.client_name
      },
      time_zone: payload.time_zone,
      time_zone_offset: payload.timezone && (-1 * moment().tz(payload.time_zone)._offset),
      hashtag: payload.hashtag,
      company_promo: payload.company_promo,
      hashtag_enabled: payload.hashtag_enabled,
      company_promo_enabled: payload.company_promo_enabled,
    });

    return (
      authedFormRequest('v2/channels', token, {
        method: 'POST',
        body: params
      }).then(r => {
        return normalize(r, channel).entities}))
  }

export const formPatchChannel =
  (token, id, {
    client_name,
    channel_theme_id,
    first_line_text,
    second_line_text,
    with_photo_filter,
    with_photo_filter_graphic,
    ...params
  }) =>
    authedFormRequest(`v2/channels/${id}`, token, {
      method: 'PATCH',
      body: setFormData('channel', params)
    }).then(r => normalize(r, channel).entities);

export const patchChannel =
  (token, id, {
    client_name,
    channel_theme_id,
    channel_theme_instance,
    first_line_text,
    second_line_text,
    first_line_font_shrink,
    second_line_font_shrink,
    app_background_color,
    with_photo_filter,
    with_photo_filter_graphic,
    ...rest
  }
) => {
  const params = objectToFormData({
    channel: {
      app_background_color,
      ...rest,
      channel_theme_instance_attributes: {
        id: channel_theme_instance.id,
        channel_theme_id,
        first_line_text,
        second_line_text,
        first_line_font_shrink,
        second_line_font_shrink,
        with_photo_filter,
        with_photo_filter_graphic,
      },
      channel_image_customization: rest.channel_image_customization || {
        is_black_and_white_mode_enabled: false,
        is_glitch_mode_enabled: false,
      },
      active_until: rest.active_until
        ? !isString(rest.active_until)
          ? rest.active_until.format()
          : rest.active_until
        : "",
      event_date: rest.event_date
        ? !isString(rest.event_date)
          ? rest.event_date.format()
          : rest.event_date
        : "",
    },
    client: {
      name: client_name,
    },
  });
  if (rest.big_logo_image_url === null) {
    params.append("channel[big_logo_image_url]", null);
  }
  if (rest.overlay_image === null) {
    params.append("channel[overlay_image]", null);
  }
  if (rest.gallery_banner === null) {
    params.append("channel[gallery_banner]", null);
  }
  if (rest.photo_filters === null) {
    params.append("channel[photo_filters]", null);
  }
  return authedFormRequest(`v2/channels/${id}`, token, {
    method: "PATCH",
    body: params,
  }).then((r) => normalize(r, channel).entities);
};



// WEBPACK FOOTER //
// ./src/utils/api/channels.js